import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { DashboardStats } from '../../types/dashboard';
import { config } from '../../config';
import { tokenManager } from '../../utils/tokenManager';

// Create axios instance with base configuration
const api = axios.create({
    baseURL: config.API_BASE_URL,
    withCredentials: true,
});

// Add request interceptor for authentication
api.interceptors.request.use(
    async (config) => {
        const token = await tokenManager.getToken();
        const authType = tokenManager.getAuthType();
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        if (authType) {
            config.headers['X-Auth-Type'] = authType.toLowerCase();
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export const fetchDashboardStats = createAsyncThunk<DashboardStats>(
    'dashboard/fetchStats',
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get<DashboardStats>('/dashboard-stats');
            return response.data;
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.error || 'Failed to fetch dashboard stats');
            }
            return rejectWithValue('Network error occurred');
        }
    }
); 